import { render, staticRenderFns } from "./recentArticlesList.vue?vue&type=template&id=ecd92920"
import script from "./recentArticlesList.vue?vue&type=script&lang=js"
export * from "./recentArticlesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports